import { List } from 'immutable';
import { DesignTemplates } from 'records/DesignTemplate';
import BaseList from 'records/BaseList';

import {
  CLEAN_SIMPLE_DESIGN_TEMPLATES_ASYNC_ACTION_START,
  CLEAN_SIMPLE_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR,
  CLEAN_SIMPLE_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS,
  CLEAN_SIMPLE_DESIGN_TEMPLATES_RESET_STATE,
} from 'actions/cleanSimpleDesignTemplates';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [CLEAN_SIMPLE_DESIGN_TEMPLATES_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [CLEAN_SIMPLE_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [CLEAN_SIMPLE_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: DesignTemplates(action.data),
    });
  },
  [CLEAN_SIMPLE_DESIGN_TEMPLATES_RESET_STATE]: () => {
    return initialState;
  },
};

export default function cleanSimpleDesignTemplates(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
